import React from 'react';

const TextArea = ({ label, name, register, errors, validationRules = {}, placeholder = "", ...rest }) => (
  <div className="form-control">
    <label className="label">
      <span className="label-text">{label}</span>
    </label>
    <textarea
      name={name}
      className="textarea textarea-bordered h-24"
      {...register(name, validationRules)}
      placeholder={placeholder}
      {...rest}
    />
    {errors[name] && <span className="text-error">{errors[name].message}</span>}
  </div>
);

export default TextArea;
